import React from "react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Circle, Clock, Ban, Database } from "lucide-react";
import { TaskSubStatus } from "@/types/productFeed";

const getStatusBadge = (status: string) => {
    switch (status) {
        case 'started':
            return <Badge className="bg-blue-100 text-blue-700">Started</Badge>;
        case 'completed':
            return <Badge className="bg-green-100 text-green-700">Completed</Badge>;
        case 'failed':
            return <Badge className="bg-red-100 text-red-700">Failed</Badge>;
        case 'in-progress':
            return <Badge className="bg-orange-100 text-orange-700">In-Progress</Badge>;
        case 'inprogress':
            return <Badge className="bg-orange-100 text-orange-700">In-Progress</Badge>;
        case 'not-started':
            return <Badge className="bg-gray-100 text-gray-700">Not Started</Badge>;
        default:
            return <Badge className="bg-gray-100 text-gray-700">{JSON.stringify(status)}</Badge>;
    }
};

const getStatusIcon = (status: string) => {
    switch (status) {
        case 'started':
            return <Clock className="h-5 w-5 text-blue-600" />;
        case 'completed':
            return <CheckCircle className="h-5 w-5 text-green-600" />;
        case 'failed':
            return <Ban className="h-5 w-5 text-red-600" />;
        case 'in-progress':
            return <Clock className="h-5 w-5 text-orange-600" />;
        case 'inprogress':
            return <Clock className="h-5 w-5 text-orange-600" />;
        case 'not-started':
            return <Circle className="h-5 w-5 text-gray-400" />;
        case 'notstarted':
            return <Database className="h-5 w-5 text-gray-400" />;
        default:
            return null;
    }
};

const SubTask: React.FC<{ subTasks: TaskSubStatus[] }> = ({ subTasks }) => {
    if(subTasks.length === 0) return <p>No sub-tasks available.</p>;
    return (
        <Card>
            <CardHeader>
                <CardTitle className="text-lg font-semibold">Sub Tasks</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="space-y-4">
                    {subTasks.map((task) => (
                        <div key={task.task} className="flex items-center justify-between">
                            <div className="flex items-center space-x-3">
                                {getStatusIcon(task.status)}
                                <span className="text-sm font-medium">{task.task}</span>
                            </div>
                            {getStatusBadge(task.status)}
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
};

export default SubTask;